import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './product-offering.reducer';

export const ProductOfferingDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const productOfferingEntity = useAppSelector(state => state.productOffering.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="productOfferingDetailsHeading">
          <Translate contentKey="crawlerBackendApp.productOffering.detail.title">ProductOffering</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{productOfferingEntity.id}</dd>
          <dt>
            <span id="contractType">
              <Translate contentKey="crawlerBackendApp.productOffering.contractType">Contract Type</Translate>
            </span>
          </dt>
          <dd>{productOfferingEntity.contractType}</dd>
          <dt>
            <span id="variant">
              <Translate contentKey="crawlerBackendApp.productOffering.variant">Variant</Translate>
            </span>
          </dt>
          <dd>{productOfferingEntity.variant}</dd>
          <dt>
            <span id="commercialBusiness">
              <Translate contentKey="crawlerBackendApp.productOffering.commercialBusiness">
                Commercial Business
              </Translate>
            </span>
          </dt>
          <dd>{productOfferingEntity.commercialBusiness}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.productOffering.productSpecification">
              Product Specification
            </Translate>
          </dt>
          <dd>{productOfferingEntity.productSpecification ? productOfferingEntity.productSpecification.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.productOffering.supplier">Supplier</Translate>
          </dt>
          <dd>{productOfferingEntity.supplier ? productOfferingEntity.supplier.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/product-offering" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/product-offering/${productOfferingEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProductOfferingDetail;
